// extracted by mini-css-extract-plugin
var _1 = "EntityTabAttributesEntry-moduleitem__i4bdj";
var _2 = "EntityTabAttributesEntry-modulelabel__jzzmq";
var _3 = "EntityTabAttributesEntry-moduleplaceholder__RluXa";
var _4 = "EntityTabAttributesEntry-modulevalue__qGnHV";
var _5 = "EntityTabAttributesEntry-modulevalueColumn__StHyy";
export { _1 as "item", _2 as "label", _3 as "placeholder", _4 as "value", _5 as "valueColumn" }
